import type { DocumentRequirement } from "@/services/api/case-checking/rule-sets";

/** Human labels for Tab 2 transaction subtypes (checklist section headers). */
export const TRANSACTION_SUBTYPE_LABELS: Record<string, string> = {
  "fund-switch": "Fund Switch",
  "top-up": "Top Up",
  "platform-transfer": "Platform Transfer",
  "new-business": "New Business Report",
  "pension-drawdown": "Pension Drawdown (First-time FAD)",
  "bond-withdrawal": "Bond Withdrawal",
  "isa-gia-withdrawal": "ISA & GIA Withdrawal",
  "ad-hoc-pension-withdrawal": "Ad hoc Pension Withdrawal",
  "annual-review": "Annual Review",
  "high-risk": "High Risk",
  trust: "Trust",
  mortgage: "Mortgage",
  annuity: "Annuity",
};

export function effectiveCaseTypes(
  caseType: string,
  caseTypes?: string[] | null,
): string[] {
  const nonProduct = new Set(["multi-product", "unknown"]);
  if (caseTypes?.length) {
    const out = caseTypes.filter((t) => t && !nonProduct.has(t));
    if (caseType && !nonProduct.has(caseType) && !out.includes(caseType)) {
      return [caseType, ...out];
    }
    return out;
  }
  return caseType && !nonProduct.has(caseType) ? [caseType] : [];
}

/** Mirrors case_scoping.document_requirement_applies on the API. */
export function documentRequirementApplies(
  req: DocumentRequirement,
  caseType: string,
  caseTypes: string[] | undefined | null,
  transactionSubtype: string | null | undefined,
): boolean {
  const types = effectiveCaseTypes(caseType, caseTypes);
  const txn = (transactionSubtype ?? "").trim() || null;
  const rawTypes = req.case_types ?? [];
  const reqSub = (req.transaction_subtype ?? "").trim() || null;

  if ((!rawTypes.length || rawTypes.includes("ALL")) && !reqSub) {
    return true;
  }

  const caseMatch =
    rawTypes.length > 0 &&
    !rawTypes.includes("ALL") &&
    types.length > 0 &&
    rawTypes.some((t) => types.includes(t));

  const txnMatch = Boolean(reqSub && txn && reqSub === txn);

  if (rawTypes.length > 0 && !rawTypes.includes("ALL") && !reqSub) {
    return caseMatch;
  }
  if (reqSub && !rawTypes.length) {
    return txnMatch;
  }
  if (rawTypes.length > 0 && reqSub && !rawTypes.includes("ALL")) {
    return caseMatch || txnMatch;
  }
  if (rawTypes.includes("ALL") && reqSub) {
    return txnMatch;
  }
  return false;
}

export function transactionSubtypeLabel(subtype: string): string {
  return (
    TRANSACTION_SUBTYPE_LABELS[subtype] ??
    subtype.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
  );
}
